import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import {DEFAULT_ITEM_TYPE} from "../../constants/defaults";
import {get} from "lodash";

const ItemTypeSelect = ({ name, label = 'Item Type', control, errors, readOnly = false, helperText, onChange}) => {
    const itemTypes = [{"code": "G", "name": "Goods"}, {"code": "S", "name": "Services"}]
    const getItemTypeByCode = (code) => {
        return itemTypes.find((c) => c.code === code);
    };

    const errorMessage = get(errors, name, {})?.message;
    const combinedHelperText = [helperText, errorMessage].filter(Boolean).join(' * ');

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                const selectedItemType = getItemTypeByCode(field.value) ?? getItemTypeByCode(DEFAULT_ITEM_TYPE) ?? null;
                return (
                    <Autocomplete
                        options={itemTypes}
                        getOptionLabel={(option) => option.code}
                        isOptionEqualToValue={(option, value) => option.code === value?.code}
                        value={selectedItemType}
                        onChange={(_, selected) => {
                            const newCode = selected?.code || null;
                            field.onChange(newCode);
                            onChange?.(newCode);
                        }}
                        disableClearable={readOnly}
                        readOnly={readOnly}
                        renderOption={(props, option) => (
                            <li {...props} key={option.code}>
                                {option.code} - {option.name}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={label}
                                sx={{ minWidth: '150px' }}
                                error={!!errorMessage}
                                helperText={combinedHelperText || ''}
                            />
                        )}
                    />
                );
            }}
        />
    );
};

export default ItemTypeSelect;
